import * as React from "react";
import { strings } from "@/I18n";
import { cn } from "@/lib/utils";

export interface LoadingProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  fullPage?: boolean;
}

const Loading = React.forwardRef<HTMLDivElement, LoadingProps>(
  ({ size = "md", className, fullPage = false }, ref) => {
    const sizeClasses = {
      sm: "tw-h-4 tw-w-4 tw-border-2",
      md: "tw-h-8 tw-w-8 tw-border-2",
      lg: "tw-h-12 tw-w-12 tw-border-4",
    };

    const spinner = (
      <div
        className={cn(
          "tw-animate-spin tw-rounded-full tw-border-primary tw-border-t-transparent",
          sizeClasses[size],
          className
        )}
      />
    );

    if (fullPage) {
      return (
        <div
          ref={ref}
          className="tw-flex tw-h-full tw-min-h-[400px] tw-w-full tw-items-center tw-justify-center"
        >
          {spinner}
        </div>
      );
    }

    return (
      <div
        ref={ref}
        className="tw-flex tw-items-center tw-justify-center tw-p-4"
      >
        {spinner}
      </div>
    );
  }
);

Loading.displayName = "Loading";

export interface LoadingTextProps {
  text?: string;
  className?: string;
}

const LoadingText = React.forwardRef<HTMLDivElement, LoadingTextProps>(
  ({ text = strings("common.loading"), className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("tw-text-muted-foreground tw-text-sm", className)}
      >
        {text}
      </div>
    );
  }
);

LoadingText.displayName = "LoadingText";

export { Loading, LoadingText };
